var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPiano(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33 32",
    style: {
      enableBackground: "new 0 0 33 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2,13.9h-5.1c-1,0-1.8-0.6-2.1-1.5c0,0-1.5-4.3-1.9-5.7C17.7,2.7,14,0,9.8,0C4.5,0,0.1,4.4,0.1,9.7v21.8 c0,0.3,0.2,0.5,0.5,0.5h31c0.3,0,0.5-0.2,0.5-0.5V17.8C32.1,15.7,30.3,13.9,28.2,13.9z M9.4,31H6.2v-2h0.5c0.3,0,0.5-0.2,0.5-0.5 v-4.6h1.1v4.6c0,0.3,0.2,0.5,0.5,0.5h0.5V31z M5.2,27.9v-4.1h1v4.1H5.2z M13.5,31h-3.1v-2h0.5c0.3,0,0.5-0.2,0.5-0.5v-4.6h2.1V31z  M9.4,27.9v-4.1h1v4.1H9.4z M17.7,31h-3.1v-7.1h2.1v4.6c0,0.3,0.2,0.5,0.5,0.5h0.5V31z M21.8,31h-3.1v-2h0.5c0.3,0,0.5-0.2,0.5-0.5 v-4.6h1.1v4.6c0,0.3,0.2,0.5,0.5,0.5h0.5V31z M17.7,27.9v-4.1h1v4.1H17.7z M26,31h-3.1v-2h0.5c0.3,0,0.5-0.2,0.5-0.5v-4.6H25v4.6 c0,0.3,0.2,0.5,0.5,0.5H26V31z M21.8,27.9v-4.1h1v4.1H21.8z M27,31v-2h0.5c0.3,0,0.5-0.2,0.5-0.5v-4.6h1.5c0.3,0,0.5-0.2,0.5-0.5 c0-0.3-0.2-0.5-0.5-0.5H2.7c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5h1.5v4.6c0,0.3,0.2,0.5,0.5,0.5h0.5v2H1.1V9.7 C1.1,4.9,5,1,9.8,1c3.7,0,7.1,2.4,8.2,6c0.5,1.4,1.9,5.7,1.9,5.7c0.4,1.3,1.7,2.2,3.1,2.2h5.1c1.6,0,2.9,1.3,2.9,2.9V31H27z  M26,27.9v-4.1h1v4.1H26z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4,18.7H10.8c-0.3,0-0.5,0.2-0.5,0.5v2c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-1.5h9.5v1.5c0,0.3,0.2,0.5,0.5,0.5 s0.5-0.2,0.5-0.5v-2C21.9,19,21.7,18.7,21.4,18.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiano);
export default __webpack_public_path__ + "static/media/piano.527179cc87d6cbb0e4a3558fa48ee6ee.svg";
export { ForwardRef as ReactComponent };